import { Button } from 'primereact/button';
import { Paginator } from 'primereact/paginator';
import React from 'react';
import Guidelines from '../../features/coaching/conversationLogs/guidelines/Guidelines';

interface CoachingModalFooterProps {
    list: any[];
    first: number;
    onPageChange: (event: { first: number; rows: number }) => void;
}

const CoachingModalFooter = ({ list, first, onPageChange }: CoachingModalFooterProps) => {
    const [readGuidelines, setReadGuidelines] = React.useState(false);
    const closeGuidelines = (message: boolean) => {
        setReadGuidelines(!message);
    };
    return (
        <div className="d-flex justify-content-between mb-2">
            <Button
                label="Guidelines"
                data-testid="guidelinesButton"
                icon="ConversationGuidelinesIcon"
                onClick={() => setReadGuidelines(true)}
                className="btn-primary mt-2"
                // style={{ height: 'fit-content' }}
            />
            {list?.length > 1 && (
                <div className="d-flex justify-content-end">
                    <Paginator
                        first={first}
                        rows={1}
                        totalRecords={list.length}
                        onPageChange={onPageChange}
                        template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    />
                </div>
            )}
            {readGuidelines && (
                <Guidelines location='ConversationLogs' closeGuidelines={closeGuidelines} />
            )}
        </div>
    );
};
export default CoachingModalFooter;
